<div [class]="responsive.responsiveClassName">
  <div ut-dialog-content>
    <div class="profile-dialog__close">
      <ut-button
        variant="ghost"
        iconOnly
        iconLeft="x"
        aria-label="Close"
        (clicked)="closeDialog()"
      ></ut-button>
    </div>
    <app-profile-form (saved)="closeDialog()" (cancelled)="closeDialog()"></app-profile-form>
  </div>
</div>
